import { useEffect, useState } from 'react';

export function useCityChangeApi({ user, updateCity, updateRegion, history, disableRedirect }) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentCity, setCurrentCity] = useState(null);
  const [currentRegion, setCurrentRegion] = useState(null);

  useEffect(() => {
    if (user.regionsLoaded && user.citiesLoaded && !user.city && !user.region) {
      setIsOpen(true);
    }
  }, [user.citiesLoaded, user.regionsLoaded, user.city, user.region]);

  useEffect(() => {
    if (user.initialCityLoaded && user.initialCity) {
      setCurrentRegion(user.initialCity.region || null);
      setCurrentCity(null);
    }
  }, [user.initialCity, user.initialCityLoaded]);

  const onSelectRegion = (region) => {
    setCurrentRegion(region);
    setCurrentCity(null);
  };

  const onSelectCity = (city) => {
    setCurrentCity(city);
    setCurrentRegion(city.region || null);
  };

  const onSubmit = () => {
    if (currentCity) {
      updateCity(currentCity);
    } else if (currentRegion) {
      updateRegion(currentRegion);
    }
    setIsOpen(false);
    if (!disableRedirect) history.push('/');
  };

  return {
    isOpen,
    onSubmit,
    currentCity,
    currentRegion,
    onSelectRegion,
    onSelectCity,
  };
}
